import { useState } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Phone } from '@phosphor-icons/react';
import { AuthHeading } from '../../../../../components/auth/auth-heading';
import { OnboardingHeader } from '../../../../../components/auth/onboarding-header';
import { Button } from '../../../../../components/ui/button';
import { Input } from '../../../../../components/ui/input';
import { Toggle } from '../../../../../components/ui/toggle';
import { validatePhone } from '../../../../../lib/onboarding';
import { useOnboardingStore } from '../../../../../lib/onboarding-store';

export const Route = createFileRoute('/subdomain/app/_auth/onboarding/phone')({
  component: PhoneStep,
});

function PhoneStep() {
  const navigate = useNavigate();
  const { draft, updateDraft } = useOnboardingStore();
  const [touched, setTouched] = useState(false);

  const phoneError = validatePhone(draft.contactPhone);
  const showError = touched && draft.contactPhone.trim().length > 0 ? phoneError : undefined;

  const next = () => {
    setTouched(true);
    if (phoneError) return;
    // Always on to account creation. The route guards decide what a signed-in visitor should see instead (the audit
    // screen), so this page never trusts a possibly stale "am I signed in" value.
    void navigate({ to: '/subdomain/app/sign-up' });
  };

  return (
    <>
      <OnboardingHeader step={5} backTo="/subdomain/app/onboarding/socials" />
      <AuthHeading
        title="What’s the best number to reach you?"
        subtitle="Your account manager will use it for updates."
      />

      <Input
        label="Mobile number"
        leadingIcon={Phone}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        placeholder="+91 98765 43210"
        value={draft.contactPhone}
        error={showError}
        helperText="We never share your number."
        onChange={(e) => updateDraft({ contactPhone: e.target.value })}
        onBlur={() => setTouched(true)}
      />

      {/* TODO(api): whatsappConsent is collected but the profile endpoint has no field to store it yet. */}
      <div className="flex items-center justify-between gap-(--mbm-space-4) rounded-(--mbm-radius-md) bg-feedback-success-bg p-(--mbm-space-4)">
        <div className="flex flex-col">
          <span className="text-label-large text-text-primary">Also send updates on WhatsApp</span>
          <span className="text-body-xsmall text-text-tertiary">Approvals, meeting reminders, reports</span>
        </div>
        <Toggle
          tone="success"
          aria-label="Also send updates on WhatsApp"
          checked={draft.whatsappConsent}
          onCheckedChange={(whatsappConsent) => updateDraft({ whatsappConsent })}
        />
      </div>

      <Button fullWidth disabled={draft.contactPhone.trim().length === 0} onClick={next}>
        Continue
      </Button>
    </>
  );
}
